/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Repository
 */
export interface Repository {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   * The unique_id of an organisation
   */
  organisation?: string;
  /**
   * do not change
   */
  slug: string;
  /**
   *
   */
  readonly revision?: Array<string>;
}

/**
 * Check if a given object implements the Repository interface.
 */
export function instanceOfRepository(value: object): value is Repository {
  if (!("slug" in value) || value["slug"] === undefined) return false;
  return true;
}

export function RepositoryFromJSON(json: any): Repository {
  return RepositoryFromJSONTyped(json, false);
}

export function RepositoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Repository {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    organisation: json["organisation"] == null ? undefined : json["organisation"],
    slug: json["slug"],
    revision: json["revision"] == null ? undefined : json["revision"],
  };
}

export function RepositoryToJSON(json: any): Repository {
  return RepositoryToJSONTyped(json, false);
}

export function RepositoryToJSONTyped(
  value?: Omit<Repository, "url" | "id" | "revision"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    organisation: value["organisation"],
    slug: value["slug"],
  };
}
